export default __webpack_public_path__ + "static/media/beatriz.82c8d5d8.jpg";